
import ApiServiceAxios from '../service/ApiServiceAxios';
import MethodService from '../service/MethodService';
import { Buffer } from 'buffer';

let moduleApi = {};
let token = MethodService.getToken();
let UrlApiCos = window.MyConfig.cosUrl;

moduleApi.GetInfoUser = async (cardCode) => {

    const body = {
        "ApiData": cardCode
    };
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiCos + "CosPeople/GetByBasicInfoList?param=" + objJsonB64,
        params: {
            ApplicationCode: window.MyConfig.applicationCode831,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
};


export default moduleApi;
